import React from 'react'
import "./contact.css"
import {MdOutlineEmail} from 'react-icons/md'
import {RiMessengerLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_5d0atul', 'template_al1mdzo', form.current,'wVxRw2a_ZCa4vwP7s')

      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
  };
  return (
    <section id='contact'>
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact_container">
        <div className="contact_options">
          <article className="contact_option">
          <MdOutlineEmail className="contact_option-icon" />
            <h4>Email</h4>
            <h5>asewestephene@gmail.com</h5>
            <a href="mailto:asewestephene@gmail.com" target="_blank">Send a Message</a>
          </article>
          <article className="contact_option">
          <RiMessengerLine className="contact_option-icon" />
            <h4>Messenger</h4>
            <h5>Asewe Creatives</h5>
            <a href="https://m.me/asewe.creatives" target="_blank">Send a Message</a>
          </article>
          <article className="contact_option">
          <BsWhatsapp className="contact_option-icon" />
            <h4>WhatsApp</h4>
            <h5>+254769026177</h5>
            <a href="https://api.whatsapp.com/send?phone+254769026177" target="_blank">Send a Message</a>
          </article>
        </div>
        {/*END OF CONTACT OPTIONS*/}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="text" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type="submit" className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact